import { useQuery, useQueryClient } from '@tanstack/react-query';
import { createFileRoute, Link, useRouter } from '@tanstack/react-router';
import { Login } from '@/components/Login';
import { Settings } from '@/components/Settings';
import { Spinner } from '@/components/ui/Spinner';
import { authQueryOptions } from '@/lib/api';
import { SettingsProvider } from '@/providers/settings/SettingsProvider';

const SettingsPage = () => {
  const queryClient = useQueryClient();
  const router = useRouter();
  const { data: authStatus, isLoading: isCheckingAuth } = useQuery(
    authQueryOptions(),
  );
  const isAuthed = Boolean(authStatus);

  if (isCheckingAuth) {
    return (
      <div className="flex min-h-screen items-center justify-center">
        <Spinner />
      </div>
    );
  }

  if (!isAuthed) {
    return (
      <Login
        onSuccess={() =>
          queryClient.invalidateQueries({
            queryKey: authQueryOptions().queryKey,
          })
        }
      />
    );
  }

  const goHome = () => router.navigate({ to: '/' });

  return (
    <div className="min-h-screen">
      <nav className="sticky top-0 z-50 border-b border-border bg-surface/50 backdrop-blur-sm">
        <div className="mx-auto max-w-3xl px-4 sm:px-6 lg:px-8">
          <div className="flex h-14 items-center gap-4">
            <Link
              className="text-sm lg:text-base text-foreground-muted transition-colors hover:text-foreground"
              to="/"
            >
              &larr; Back
            </Link>
            <h1 className="text-sm lg:text-base font-semibold">Settings</h1>
          </div>
        </div>
      </nav>

      <main className="mx-auto max-w-3xl px-4 py-8 sm:px-6 lg:px-8">
        <SettingsProvider
          onClose={goHome}
          onPendingNavigationResolved={(confirmed) => {
            if (confirmed) {
              goHome();
            }
          }}
          onReplayOnboarding={goHome}
        >
          <Settings />
        </SettingsProvider>
      </main>
    </div>
  );
};

export const Route = createFileRoute('/settings')({
  component: SettingsPage,
});
